document.addEventListener("DOMContentLoaded", function() {
    // Get all <a> tags representing the main menu items
    var menuItems = document.querySelectorAll('a.parent-link--true, a.parent-link--false');

    menuItems.forEach(function(menuItem) {
        menuItem.addEventListener('click', function(e) {
            // If the clicked element has a child with the 'data-nav-title' attribute, use that for the name
            let titleElement = e.target.querySelector('[data-nav-title]');
            let menuItemName = titleElement ? titleElement.innerText.trim() : e.target.innerText.trim();
            sendDataLayerEvent(menuItemName);
        });
    });
});


function sendDataLayerEvent(menuItemName) {
    if (window.dataLayer) {
        window.dataLayer.push({
            'event': 'menuItemClicked',
            'menuItemName': menuItemName
        });
    }
};
